<template>
  <section class="mb-6">
    <h3 class="color--nice-black font--m-3">{{ request.wholesaler.name }}</h3>
    <h3 class="color--nice-black font--m-1">{{ request.amount | commaFormat }}원</h3>
    <v-layout class="content-row">
      <span>계좌 정보</span>
      <span>{{ request.bank | bankShortName }} {{ request.accountNumber }}</span>
    </v-layout>
    <v-layout class="content-row">
      <span>입금자명</span>
      <span>{{ request.depositName }}</span>
    </v-layout>
    <v-layout class="content-row">
      <span>신청 상태</span>
      <span>{{ request.status | code('CreditPaysRequest.Status') }}</span>
    </v-layout>
    <v-layout class="content-row">
      <span>신청일시</span>
      <span>{{ request.created | moment('YYYY년 MM월 DD일 HH:mm') }}</span>
    </v-layout>
  </section>
</template>

<script>
export default {
  props: ['request'],
}
</script>

<style lang="scss" scoped>
.content-row {
  justify-content: space-between;

  span:nth-of-type(1) {
    padding: 4px;
    flex-basis: 30%;
  }
  span:nth-of-type(2) {
    text-align: right;
    flex-basis: 70%;
    font-weight: 700;
  }
  span {
    padding: 4px;
    flex-grow: 0;
  }
}
</style>
